import { UserModulePushStatus } from 'user/model/module/push/user-module-push-status';

export class UserModulePush {
	private _emailId: string;
	private _contactId: string;
	private _contactName: string;
	private _contactLanguage: string;
	private _pushOrgModuleId: string;
	private _contactEmailAddress: string;
	private _status: UserModulePushStatus;

	constructor(
		emailId: string,
		contactId: string,
		contactName: string,
		contactLanguage: string,
		pushOrgModuleId: string,
		contactEmailAddress: string,
		status: UserModulePushStatus
	) {
		this._emailId = emailId;
		this._contactId = contactId;
		this._contactName = contactName;
		this._contactLanguage = contactLanguage;
		this._pushOrgModuleId = pushOrgModuleId;
		this._contactEmailAddress = contactEmailAddress;
		this._status = status;
	}

	public get emailId(): string {
		return this._emailId;
	}

	public get contactId(): string {
		return this._contactId;
	}

	public get contactName(): string {
		return this._contactName;
	}

	public get contactLanguage(): string {
		return this._contactLanguage;
	}

	public get pushOrgModuleId(): string {
		return this._pushOrgModuleId;
	}

	public get contactEmailAddress(): string {
		return this._contactEmailAddress;
	}

	public get status(): UserModulePushStatus {
		return this._status;
	}

	public get isAnswered(): boolean {
		return this._status === UserModulePushStatus.ANSWERED;
	}
}
